export default {
  subTitle: {
    id: 'gift_cards_results_sub_title',
    defaultMessage: 'Just like that...',
  },
  title: {
    id: 'gift_cards_results_title',
    defaultMessage: 'You’re a gifter!',
  },
  mainText: {
    id: 'gift_cards_results_main_text',
    defaultMessage:
      'Your gift card is on its way. We’ll email you a link to download it.',
  },
  yourOrder: {
    id: 'gift_cards_results_your_order',
    defaultMessage: 'Your order',
  },
  total: {
    id: 'gift_cards_results_total',
    defaultMessage: 'Total',
  },
}
